import React, { useState } from "react";
import { Button, Modal } from "antd";
import "./index.css";

const MyMenuSurveyTableCommentModal = ({ comment, maxLength = 35 }) => {
  const [open, setOpen] = useState(false);

  if (!comment) return <span>-</span>;

  const isLong = comment.length > maxLength;
  const shortComment = isLong ? comment.slice(0, maxLength) + "..." : comment;

  return (
    <>
      <span>
        {shortComment}
        {isLong && (
          <Button
            onClick={() => setOpen(true)}
            type="link"
            className="mymenu-survey-modal-show-more-button"
          >
            Виж още
          </Button>
        )}
      </span>
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        title="Коментар"
      >
        <p style={{ whiteSpace: "pre-wrap" }}>{comment}</p>
      </Modal>
    </>
  );
};

export default MyMenuSurveyTableCommentModal;
